import React from 'react';
import './Content.scss';

export default function Content({ children }) {
  return <div className="Content">{children}</div>;
}
